import './MonitorFormListCard.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { EditMonitorFooter } from '../../monitors/monitor-form/EditMonitorFooter';
import { EditOutlined } from '@ant-design/icons';
import { isEqual } from 'lodash';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import { Card, Space } from 'antd';
import { MonitorMenu, monitorMenuConfigs } from '../../monitors/monitor-form/MonitorMenu';
import React, { useCallback, useEffect, useState } from 'react';
import { useCurrentUser } from '@hooks';
const intrinsicMenuItems = () => monitorMenuConfigs.filter((x) => x.intrinsic);
export const MonitorFormListCard = ({ fieldId, form, isNew, monitors, onCancel, onDelete, onEdit, onSave }) => {
    var _a, _b;
    const [currentMonitor, setCurrentMonitor] = useState(form.getItem(fieldId));
    const { isReadOnly } = useCurrentUser();
    const isIntrinsic = ((_a = currentMonitor === null || currentMonitor === void 0 ? void 0 : currentMonitor.monitorConfig) === null || _a === void 0 ? void 0 : _a.monitorTypeId) &&
        ((_b = monitorMenuConfigs.find((x) => { var _a; return x.type === ((_a = currentMonitor.monitorConfig) === null || _a === void 0 ? void 0 : _a.monitorTypeId); })) === null || _b === void 0 ? void 0 : _b.intrinsic);
    const [isEditing, setIsEditing] = useState(form.getItemState(fieldId, currentMonitor.id || isIntrinsic ?
        undefined :
        true).isInEdit);
    useEffect(() => {
        const tempMonitor = form.getItem(fieldId);
        if (!isEqual(currentMonitor, tempMonitor)) {
            setCurrentMonitor(tempMonitor);
        }
    }, [form, fieldId, currentMonitor, setCurrentMonitor]);
    const setEditing = useCallback((value) => {
        form.setEdit(fieldId, value, true);
        setIsEditing(value);
    }, [fieldId, form]);
    const handleOnClick = useCallback((e) => {
        if (isEditing || isReadOnly) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (!isReadOnly) {
            setEditing(true);
        }
        form.validate();
        if (onEdit) {
            onEdit();
        }
    }, [form, isEditing, isReadOnly, onEdit, setEditing]);
    const handleOnChange = useCallback((newMonitor) => {
        var _a;
        setCurrentMonitor(newMonitor);
        form.setFieldValue(['monitors', fieldId, 'monitorConfig', 'monitorTypeId'], (_a = newMonitor.monitorConfig) === null || _a === void 0 ? void 0 : _a.monitorTypeId);
    }, [form, setCurrentMonitor, fieldId]);
    const handleOnSave = useCallback(() => {
        setEditing(false);
        onSave();
    }, [onSave, setEditing]);
    const handleOnCancel = useCallback(() => {
        setEditing(false);
        onCancel();
    }, [onCancel, setEditing]);
    const getName = useCallback(() => {
        if (!currentMonitor.id || !(currentMonitor === null || currentMonitor === void 0 ? void 0 : currentMonitor.name)) {
            return COPY_SPECIFIC.CREATE_NEW_MONITOR;
        }
        return isEditing ?
            COPY_SPECIFIC.EDITING_LABEL(currentMonitor.name) :
            currentMonitor.name;
    }, [currentMonitor, isEditing]);
    if (!monitors && !currentMonitor) {
        return null;
    }
    return (React.createElement(Card, { className: classNames('monitor-card', {
            'can-edit': !isEditing && !isReadOnly
        }), extra: React.createElement(When, { condition: !isEditing },
            React.createElement(EditOutlined, { className: 'edit-icon' })), onClick: handleOnClick, title: React.createElement(SonarText, { className: 'h3' }, getName()), variant: 'borderless' },
        React.createElement(Space, { className: 'monitor-card-body', direction: 'vertical' },
            React.createElement(Space, { align: 'start', direction: 'vertical' },
                React.createElement(MonitorMenu, { editing: isEditing, fieldId: fieldId, hideApplications: true, menuOptions: 'applicationRequired', monitor: currentMonitor, onChange: handleOnChange, overrideMonitors: isNew ? monitors : [currentMonitor] })),
            React.createElement(When, { condition: isEditing },
                React.createElement(EditMonitorFooter, { disableSave: !form.getItemState(fieldId).isValid, monitor: currentMonitor, onCancel: handleOnCancel, onDelete: !intrinsicMenuItems()
                        .find((x) => { var _a; return x.type === ((_a = currentMonitor.monitorConfig) === null || _a === void 0 ? void 0 : _a.monitorTypeId); }) &&
                        onDelete ? () => onDelete() : undefined, onSave: handleOnSave })))));
};
